import Seo from '@/components/Seo';
import { SITE } from '@/lib/site';
import { getSeo } from '@/lib/seo';

export default function Terms() {
  return (
    <>
      <Seo
        path="/terms"
        fullTitle={getSeo('terms').title}
        description={getSeo('terms').description}
        ogImage={getSeo('terms').og_image ?? undefined}
      />
      <article className="mx-auto max-w-prose px-5 py-20 sm:px-8 sm:py-24">
        <p className="text-sm font-medium uppercase tracking-wider text-accent">
          Terms
        </p>
        <h1 className="mt-3 font-display text-4xl">Terms of service</h1>
        <p className="mt-2 text-sm text-fg-subtle">
          Last updated: 26 April 2026
        </p>

        <div className="mt-10 space-y-6 text-fg-muted">
          <p>
            These terms govern your use of <a className="link" href={SITE.url}>{SITE.url}</a>{' '}
            and any services we provide. By using the site or engaging us for
            work, you agree to them. If you don't agree, please don't use the site.
          </p>

          <H2>Who we are</H2>
          <p>
            "We", "us", and "our" mean {SITE.name}, an online-only studio
            based in the United Kingdom. Contact: {SITE.email}, {SITE.phone}.
          </p>

          <H2>Use of the site</H2>
          <p>
            You may browse this site and submit enquiries via the contact form.
            You may not attempt to interfere with the site, scrape it at scale,
            probe it for vulnerabilities without permission, or use it to send
            unsolicited messages.
          </p>

          <H2>Quotes and engagements</H2>
          <p>
            Any pricing shown on the site is indicative. A formal quote is only
            binding once we send it to you in writing and you accept it in
            writing. Each engagement is governed by a separate agreement that
            sets out scope, deliverables, timeline, and price. Hosting is
            offered only as part of a development engagement, not as a
            standalone product.
          </p>

          <H2>Intellectual property</H2>
          <p>
            The text, code, design, and branding of this website are
            owned by {SITE.name} unless explicitly noted otherwise. You may
            link to the site freely; please don't republish substantial
            portions of it without permission.
          </p>

          <H2>Liability</H2>
          <p>
            We do our best to keep the site accurate and available, but we
            don't guarantee that it will be uninterrupted or error-free. To
            the extent permitted by law, we exclude liability for indirect or
            consequential losses arising from your use of the site. Nothing
            in these terms limits liability where it can't lawfully be
            limited (for example, for fraud or death/personal injury caused
            by negligence).
          </p>

          <H2>Governing law</H2>
          <p>
            These terms are governed by the laws of England and Wales, and
            disputes are subject to the exclusive jurisdiction of the English
            courts.
          </p>

          <H2>Changes</H2>
          <p>
            We may update these terms from time to time. The "last updated"
            date above will reflect any change.
          </p>
        </div>
      </article>
    </>
  );
}

function H2({ children }: { children: React.ReactNode }) {
  return <h2 className="mt-10 text-2xl text-fg-base">{children}</h2>;
}
